import React, { useState, useEffect } from 'react'
import { Formik, Form } from 'formik'
import FormikControl from '../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import Fetcher from '../../../src/hoc/FetcherSetting/FetcherSetting'
import ToastInstance from '../../../src/hoc/NotificationSettings/ToastInstance'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import moment from 'moment'
import * as Yup from 'yup'
function Assign() {
    const history = useHistory();
    const [leadauditorList, setLeadauditorList] = useState([{
        label: "",
        value: ""
    }])
    const { orgcode } = useParams()
    const [assitAuditorList, setassitAuditorList] = useState([{
        label: "",
        value: ""
    }])
    const [tempOrgCode, settempOrgCode] = useState(0)
    const [initialValues, setInitialValues] = useState({
        orgCode: 0,
        dateofaudit: "",
        duedate: "",
        purpose: "",
        standardapplied: "",
        scope: "",
        auditrepresentative: "",
        contactno: "",
        teamleaderName: "",
        contactno1 : "",

        auditorOne: "",
        auditorOneName: "",
        contactno2: "",
        technicalExpertName: "",
        contactno3: "",
        datesur: new Date(),
        surveillanceType: "",
        surveillanceTypeName: ""
    })
    const types = [
        { label: "Select", value: "-" },
        { label: "Suveillance 1", value: "Sureillance1" },
        { label: "Surveillance 2", value: "Surveillance2" }

    ]
    const onSubmit = (values, { setSubmitting, resetForm }) => {
        if(values.surveillanceType ===  "Sureillance1" )
        {
           mutation.mutate(values)
           console.log("values 54",values)
        }
        else
        {
           mutationSurveillancetwo.mutate(values)
        }
     

    }
    const mutationAssisAuditorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforAssistAuditorCommonNacecode/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                setassitAuditorList(data.data.response)

            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationLeadAudiorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforleadauditorsCommonNacecode/' + params, {}), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                console.log("setLeadauditorList",data.data.response)
                setLeadauditorList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutation = useMutation((params) => Fetcher('patch', '/api/survillance/patch/surveillancedetails', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', ' Surveillance Data Filled')
               window.location.href = "/" + localStorage.getItem("role") + "/view/surveillanceauditassign/" + data.data.response.orgCode
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })

    const mutationSurveillancetwo = useMutation((params) => Fetcher('patch', '/api/survillanceTwo/patch/surveillancetwodetails', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', ' Surveillance Two Audit Assign Data Filled')
               window.location.href = "/"+localStorage.getItem("role")+"/view/surveillancetwoauditassign/" + data.data.response.orgCode
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const { data: OrgList, isLoading: companyListLoading } = useQuery(
        'listAuditPlan',
        () => Fetcher('get', '/api/clientaccess/get/stagetwocompanylistbyroleforsurvillance/' + localStorage.getItem("userCode"), {}))

    const typeofaudit = [
        { key: 'Surveillance Audit 1', value: 'Surveillance Audit 1' },
        { key: 'Surveillance Audit 2', value: 'Surveillance Audit 2' }
    ]

    const mutationgetCompanyDetailsSurveillanceOne = useMutation((params) => Fetcher('get', '/api/survillance/get/surveillancedata/' + params, {},console.log("paramas",params)), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null
                tempInitialValues.surveillanceType = data.data.response.surveillanceType || "Sureillance1"
                tempInitialValues.surveillanceTypeName = data.data.response.surveillanceTypeName || "Sureillance 1"
                tempInitialValues.datesur = Date.parse(data.data.response.datesur) || null
                tempInitialValues.purpose = data.data.response.purpose || ""
                tempInitialValues.standardapplied = data.data.response.standardapplied || ""
                tempInitialValues.scope = data.data.response.scope || ""
                tempInitialValues.auditrepresentative = data.data.response.auditrepresentative || ""
                tempInitialValues.teamleader = data.data.response.teamleader || ""
                tempInitialValues.teamleaderName = data.data.response.teamleaderName || ""
                tempInitialValues.auditorOneName = data.data.response.auditorOneName || ""
                tempInitialValues.technicalExpertName = data.data.response.technicalExpertName || ""
                if(!data.data.response.duedate){
                    var dueDate1 = moment(data.data.response.dateofaudit).add(365,'days')
                    var tempDueDate = dueDate1._d  
                    tempInitialValues.duedate = tempDueDate   
                    
                }
                else{
                    tempInitialValues.duedate = Date.parse(data.data.response.duedate) || null
                }
                setInitialValues(tempInitialValues)
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationLeadAudiorDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationAssisAuditorDetails.mutate(tempInitialValues.nacecode)
                }
            }
            else {
                var msg = 'Surveillance One - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }

    })
   
    const mutationgetCompanyDetailSurveillanceTwo = useMutation((params) => Fetcher('get', '/api/survillanceTwo/get/surveillancetwodata/' + params, {}), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                 tempInitialValues.surveillanceType = data.data.response.surveillanceType || "Sureillance2"
                 tempInitialValues.surveillanceTypeName = data.data.response.surveillanceTypeName || "Sureillance 2"
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null
                tempInitialValues.datesur = Date.parse(data.data.response.datesur) || null
                tempInitialValues.purpose = data.data.response.purpose || ""
                tempInitialValues.standardapplied = data.data.response.standardapplied || ""
                tempInitialValues.scope = data.data.response.scope || ""
                tempInitialValues.auditrepresentative = data.data.response.auditrepresentative || ""
                tempInitialValues.teamleader = data.data.response.teamleader || ""
                tempInitialValues.teamleaderName = data.data.response.teamleaderName || ""
                tempInitialValues.auditorOneName = data.data.response.auditorOneName || ""
                tempInitialValues.technicalExpertName = data.data.response.technicalExpertName || ""
                tempInitialValues.duedate = Date.parse(data.data.response.duedate) || null
                //tempInitialValues.nacecode = data.data.response.nabcbcode || "";
                setInitialValues(tempInitialValues)
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationLeadAudiorDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationAssisAuditorDetails.mutate(tempInitialValues.nacecode)
                }
            }
            else {
                var msg = 'Surveillance Two- ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }

    })
    const validationSchema = Yup.object({ 
        contactno            :  Yup.string().required('Required').matches(/^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$/, "Phone Number is Invalid!!!"),
        contactno1          :  Yup.string().required('Required').matches(/^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$/, "Phone Number is Invalid!!!"),
        // contactno2          :  Yup.string().required('Required').matches(/^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$/, "Phone Number is Invalid!!!"),
        


    })
  
    if (companyListLoading) return <h1>Loading</h1>

    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >

                {
                    formik => <Form>
                        <div className="content-wrapper">
                            <section className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <div className="formOuterDiv">

                                                            <div className="form1RowDiv">
                                                            <label className="formSingleElementLabel mt-3 ">Client Name
                                                                    <span className="required-field"> *</span>
                                                            </label>
                                                                <FormikControl control='selectNACECode' options={OrgList.data.response} name='orgCode' type="text"  onChange={(e) => {
                                                                    formik.setFieldValue(`orgCode`, e.value)
                                                                    formik.setFieldValue(`orgName`, e.label)
                                                                    settempOrgCode(e.value)

                                                                }} />

                                                            </div>

                                                            <div className="form1RowDiv mt-3">
                                                            <label className="formSingleElementLabel ">Surveillance Type 
                                                                    <span className="required-field"> * </span>
                                                            </label>
                                                                <FormikControl control='selectNACECode' options={types}  name='surveillanceType' 
                                                                   
                                                                onChange={e => {
                                                                    formik.setFieldValue(`surveillanceType`, e.value)
                                                                    formik.setFieldValue(`surveillanceTypeName`,e.label)
                                                                   
                                                                e.value === 'Sureillance1' ? 
                                                                 mutationgetCompanyDetailsSurveillanceOne.mutate(tempOrgCode)
                                                                :mutationgetCompanyDetailSurveillanceTwo.mutate(tempOrgCode)
                                                            
                                                                }} type="text"/> 

                                                            </div> 
                                                            <div className="form2RowDiv mt-3">
                                                                <FormikControl control='date' dateFormat="dd-MM-yyyy" name='dateofaudit' className="form-control" label='Certification Audit Done ' disabled={true}
                                                                
                                                                />
                                                                <FormikControl control='date' dateFormat="dd-MM-yyyy" name='duedate' className="form-control" label='Due Date'  />
                                                            </div>
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type="text" name='purpose' label='Purpose of Audit ' className="form-control" />
                                                            </div>
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type="text" name='standardapplied' label='Standard Applied' className="form-control" />
                                                            </div>
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type="text" name='scope' label='Scope of Application' className="form-control" />
                                                            </div>
                                                            <div className="hrstyle  headingcolor">
                                                                <h5>Auditee’s Representative</h5>
                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type='text' label='Name' name='auditrepresentative' />
                                                                <FormikControl control='input' type='text' label='Contact No *' name='contactno' />
                                                            </div>
                                                            <div className="hrstyle  headingcolor">
                                                                <h5>Lead Auditor</h5>
                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control="selectNACECode" name="teamleader" label="Team Leader/ Lead Auditor" options={leadauditorList}
                                                                    onChange={(e) => {
                                                                        formik.setFieldValue(`teamleader`, e.value)
                                                                        formik.setFieldValue(`teamleaderName`, e.label)
                                                                    }}
                                                                />
                                                                <FormikControl control='input' type='text' label='Contact No *' name='contactno1' />
                                                            </div>
                                                            <div className="hrstyle headingcolor">
                                                                <h5>Auditor (If Any)</h5>
                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control="selectNACECode" name="auditorOne" label='Name' options={assitAuditorList}
                                                                    onChange={(e) => {
                                                                        formik.setFieldValue(`auditorOne`, e.value)
                                                                        formik.setFieldValue(`auditorOneName`, e.label)
                                                                    }}
                                                                />

                                                                
                                                                <FormikControl control='input' type='text' label='Contact No' name='contactno2' />
                                                            </div>
                                                            <div className="hrstyle  headingcolor">
                                                                <h5>Technical Expert (If Any)</h5>
                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type='text' label='Name' name='technicalExpertName' />
                                                                <FormikControl control='input' type='text' label='Contact No ' name='contactno3' />
                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='date' dateFormat="dd-MM-yyyy" name='datesur' className="form-control" label='Date *' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </section>

                            <div className="card-footer">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <button type="submit" className="btn btn-primary" >Submit</button>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </Form>
                }
            </Formik>
        </div>
    )
}

export default Assign